<span>&copy; {{settings.app.year}} - {{ settings.app.name }} - version {{ settings.app.version }}</span>